import $ from 'jquery';

export const RealEstateSearchResultListWithLoanComponent = {
	bindings: {
		realEstateList: '<',
		realEstateSearchResponse: '<',
		searchPagerOrOrder: '&'
	},
	templateUrl: 'real-estate-with-loan-list.html',
	controller: class RealEstateSearchResultListWithLoanComponent {
		constructor(SearchesService, $timeout, favouriteService, $rootScope) {
			'ngInject';
			this.searchesService = SearchesService;
			this.favouriteService = favouriteService;
			this.$timeout = $timeout;
			this.$rootScope = $rootScope;
		}

		$onInit() {
			this.isLoggedIn = this.$rootScope.isLoggedIn;
			this.initSliders();
		}

		initSliders() {
			let vm = this;
			if (this.propertyList && this.propertyList.length && angular.element('.m29-loan-slick_' + this.propertyList[0].comissionId).length) {
				this.propertyList.forEach(e => {
					vm.lazyBgImg(true, 0, e);
					angular.element('.m29-loan-slick_' + e.comissionId).on('init', (event, slick) => {
						vm.lazyBgImg(angular.element(slick.$slides.get(0)), 0, e);
					});
					angular.element('.m29-loan-slick_' + e.comissionId).on('beforeChange', (event, slick, slide, nextSlide) => {
						if (nextSlide != slide) {
							vm.lazyBgImg(angular.element(slick.$slides.get(nextSlide)), nextSlide, e);
						}
					});
				});
			} else {
				vm.$timeout(() => {
					vm.initSliders();
				}, 300);
			}
		}

		lazyBgImg(element, nextSlide, e) {
			if (element) {
				let lazyBgImgs = angular.element('.m29-loan-slick_' + e.comissionId + '_' + nextSlide);
				$.each(lazyBgImgs, function (index, el) {
					$(el).css('background-image', 'url(' + e.images[nextSlide].url + ')');
				});
			}
		}

		$onChanges(changes) {
			if (changes.realEstateList) {
				this.propertyList = angular.copy(this.realEstateList);
			}
			if (changes.realEstateSearchResponse && this.realEstateSearchResponse) {
				this.responseData = angular.copy(this.realEstateSearchResponse);
				this.size = this.responseData.size;
				this.currentPage = this.responseData.number;
			}
		}

		searchByOrder() {
			this.searchPagerOrOrder({
				$event: {
					paging: {
						page: 0,
						pageSize: this.size
					}
				}
			});
		}

		loadPage(event) {
			this.pager(event.pageTo, this.size);
		}

		pager(page, size) {
			let params = {
				page: page,
				pageSize: size
			};
			this.searchPagerOrOrder({
				$event: {
					paging: params
				}
			});
		}

		// just for logged in users
		setLiked(item, $event) {
			$event.stopPropagation();
			$event.preventDefault();
			this.item = item;
			this.favouriteService.setFavourite(this.item.comissionId).then(() => {
				this.item.liked = !this.item.liked;
			}).catch((error) => {
				console.log(error);
			});
		}

		clickOnProperty($event, property) {
			if (angular.element($event.target).is(':button')) {
				// jobbra - balra lapozott, kedvencnek jelölt
			} else {
				window.location.href = property.url;
			}
		}
	}
};
